import React from "react";
import { styled } from "goober";

type PortfolioTileProps =
  | (React.HTMLAttributes<HTMLButtonElement> &
      (
        | {
            as: "button";
          }
        | {
            as?: "button";
            onClick: React.MouseEventHandler<HTMLButtonElement>;
          }
      ))
  | (React.HTMLAttributes<HTMLDivElement> & { as?: "div" });

export function PortfolioTile({ children, ...rest }: PortfolioTileProps) {
  return (
    <Tile
      tabIndex={0}
      {...((rest.as === "button" || ("onClick" in rest && rest.onClick)) && {
        role: "button",
      })}
      {...rest}
    >
      {children}
    </Tile>
  );
}

const Tile = styled<"div" | "button">("div")`
  --gradient-color: var(--shade9-hsl);
  --bg-color: var(--shade7);
  --text-color: var(--shade1);
  --hover-bg-color: var(--shade6);
  --hover-text-color: var(--shade0);
  --wrapper-bg-color: var(--shade6);

  position: relative;
  display: grid;
  grid-template-areas:
    "action action action sub-actions"
    "title title title title";

  width: 100%;
  height: calc(var(--sp-1) * 42);
  padding: var(--sp-6);

  color: var(--text-color);

  border-radius: var(--br-lg);
  background-image: linear-gradient(
      180deg,
      hsla(var(--gradient-color) / 0) 0%,
      hsla(var(--gradient-color) / 0.75) 100%
    ),
    radial-gradient(
      50% 100% at 50% 0%,
      hsla(var(--gradient-color) / 0) 0%,
      hsla(var(--gradient-color) / 0.5) 100%
    );
  background-color: var(--bg-color);

  overflow: hidden;

  transition:
    background-color var(--transition),
    color var(--transition);

  &.has-action {
    cursor: pointer;

    &:hover {
      background-color: var(--hover-bg-color);
      color: var(--hover-text-color);
    }
  }

  & > .action {
    grid-area: action;

    & .wrapper {
      border-radius: 50%;
      width: var(--sp-11);
      height: var(--sp-11);

      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--wrapper-bg-color);

      img {
        max-width: 100%;
        max-height: 100%;
      }

      svg {
        width: var(--sp-5);
        height: var(--sp-5);
      }
    }
  }

  & > .sub-actions {
    grid-area: sub-actions;
    justify-self: end;

    & .menu-trigger {
      width: fit-content;
    }

    & .tag {
      height: fit-content;
    }
  }

  & > .title {
    grid-area: title;
    align-self: end;
    text-align: start;
  }
`;
